import {ReactComponent as Logo} from './images/ondaFontLogo.svg';
import styles from './Footer.module.css';
import { Link } from 'react-router-dom';
import { useMemo } from 'react';

const Footer = () => {
    const year = useMemo(() => {
        const now = new Date();
        return now.getFullYear();
    }, []);
    return (
        <div className={styles.Footer}>
            <div className={styles.Left}>
                <div><Link to="/imprint">Legal</Link></div>
                <div>Contact</div>
                <div>Instagram</div>
            </div>
            <div className={styles.Right}>
                <div>© {year} Onda Radio</div>
                <div>
                    Designed by <a href="https://lenzstudio.de" target="_blank" rel="noreferrer">
                    Lenz Studio
                </a>
                </div>
                <Logo />
            </div>
        </div>
    );
};

export default Footer;
